var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-right-arrow-3465428 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-368, -43)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-right-arrow-3465428-copy",
    transform: "translate(377.5988, 50) scale(-1, 1) translate(-377.5988, -50)translate(368.333, 43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.694931345,7.69488791 L16.1592386,7.69488791 L11.0403743,12.8137522 C10.7690036,13.0851229 10.7690036,13.5250144 11.0403743,13.7963851 C11.1758859,13.9322442 11.3537883,14 11.5316907,14 C11.7095932,14 11.8874956,13.9322442 12.0230072,13.7963851 L18.3281193,7.49127303 C18.59949,7.21990234 18.59949,6.7800108 18.3281193,6.50864011 L12.0233547,0.203528018 C11.7523314,-0.0678426725 11.311745,-0.0678426725 11.0407217,0.203528018 C10.769351,0.474898708 10.769351,0.914790249 11.0407217,1.18616094 L16.159586,6.30502522 L0.694931345,6.30502522 C0.311329242,6.30502522 0,6.61635446 0,6.99995657 C0,7.38355867 0.310981777,7.69488791 0.694931345,7.69488791 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowWhite);
export default __webpack_public_path__ + "static/media/left-arrow--white.1045d136f94c51eb3a075c42cca92cb3.svg";
export { ForwardRef as ReactComponent };